(function ($) {
  // Document Ready
  $(document).ready(function () {
    if ($(".mailer-card__item").length > 0) {
      // Mailer Card Package Type Interaction
      $(".mailer-card__item").each(function () {
        const $card = $(this);

        // Initialize each packages group independently
        $card.find(".mailer-card__packages").each(function () {
          const $packagesGroup = $(this);

          // Set up active states based on data attributes within this packages group
          $packagesGroup.find(".mailer-card__package-type").each(function () {
            const $packageType = $(this);
            const isActive = $packageType.attr("data-active") === "true";

            if (isActive) {
              $packageType.addClass("active");
            }
          });

          $packagesGroup.find(".mailer-card__mailer-items").each(function () {
            const $mailerItems = $(this);
            const isActive = $mailerItems.attr("data-active") === "true";

            if (isActive) {
              $mailerItems.addClass("active").show();
            } else {
              $mailerItems.removeClass("active").hide();
            }
          });
        });

        // Handle package type clicks - scoped to each packages group
        $card.find(".mailer-card__package-type").on("click", function (e) {
          e.preventDefault();

          const $clickedPackageType = $(this);
          const packageIndex = $clickedPackageType.attr("data-package-index");
          const $parentPackagesGroup = $clickedPackageType.closest(".mailer-card__packages");

          // Within this specific packages group, remove active state from all package types
          $parentPackagesGroup.find(".mailer-card__package-type").removeClass("active").removeAttr("data-active");

          // Within this specific packages group, hide all mailer items
          $parentPackagesGroup.find(".mailer-card__mailer-items").removeClass("active").hide();

          // Add active state to clicked package type
          $clickedPackageType.addClass("active").attr("data-active", "true");

          // Show the corresponding mailer items within this packages group
          const $targetMailerItems = $parentPackagesGroup.find(
            '.mailer-card__mailer-items[data-package-index="' + packageIndex + '"]'
          );
          $targetMailerItems.addClass("active").show();
        });

        // Handle keyboard navigation for package types
        $card.find(".mailer-card__package-type").on("keydown", function (e) {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            $(this).trigger("click");
          }
        });
      });
    }
    // END – Mailer Card
  });
})(jQuery);
